/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-27 22:27:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 17:18:42
 * @FilePath: /unifyxp-v2-store-portal/src/utils/Modal/index.tsx
 */
import React from 'react';
import ReactDOM from 'react-dom';
import css from './css.module.less';
import Footer from '@/src/components/Antd/Modal/ModalFooter';
import { ContentContainer } from '@/src/components/Antd/Modal/WarningModal1';
import { Icon } from '@/src/tools/icon';
import { CloseOutlined } from '@ant-design/icons';
import { Root } from '../Root';

const ModalWrapper = (props: any) => {
  const {
    children,
    containerStyle = {},
    containerStyleClassName,
    onClose,
    footerProps,
    title,
    hideIcon,
  } = props;
  return (
    <div className={css.moduleWrapper}>
      <div
        className={`${css.container} ${containerStyleClassName || ''}`}
        style={containerStyle}>
        <div className={css.titleContainer}>
          {!hideIcon && <Icon className={css.icon} type='iconinfo1' />}
          {title}
          <CloseOutlined className={css.closeIcon} onClick={onClose} />
        </div>
        <div className={css.contentContainer}> {children}</div>
        <Footer {...footerProps} />
      </div>
    </div>
  );
};
class Modal {
  el: any;
  modalRoot: any;
  root: any;
  display: boolean;
  constructor() {
    this.root = new Root();
    this.modalRoot = document.getElementById('modal-root');
    this.display = false;
  }
  modalHasDisplay() {
    this.display = true;
  }
  modalHasDestroy() {
    this.display = false;
  }

  insertDom() {
    this.modalHasDisplay();
    const el = this.root.getRoot();
    return el;
  }

  deleteDom(el?) {
    if (el) {
      this.root.delete(el);
    } else {
      this.root.clearAll();
    }
    this.modalHasDestroy();
  }

  forceError({ title, content, onCancel, onOkText, onOk, onCancelText }: any) {
    this.deleteDom();
    this._error({ title, content, onCancel, onOkText, onOk, onCancelText });
  }

  error({
    title,
    content,
    onCancel,
    onOkText,
    onOk,
    onCancelText,
    containerStyle,
  }: any) {
    if (!this.display) {
      this._error({
        title,
        content,
        onCancel,
        onOkText,
        onOk,
        onCancelText,
        danger: true,
        containerStyle,
      });
    }
  }

  info({ title, content, onCancel, onOkText, onOk, onCancelText }: any) {
    if (!this.display) {
      this._error({
        title,
        content,
        onCancel,
        onOkText,
        onOk,
        onCancelText,
        danger: false,
        hideIcon: true,
      });
    }
  }

  private _error({
    title,
    content,
    onCancel,
    onOkText,
    onOk,
    onCancelText,
    danger,
    hideIcon,
    containerStyle,
  }: any) {
    const el = this.insertDom();
    const handleOnClose = () => {
      this.deleteDom(el);
      if (onCancel) onCancel();
    };
    const handleOnOk = () => {
      this.deleteDom(el);
      if (onOk) onOk();
    };
    ReactDOM.render(
      <ModalWrapper
        hideIcon={hideIcon}
        onClose={handleOnClose}
        title={title}
        containerStyle={containerStyle}
        footerProps={{
          ...(onOk ? { onOk: handleOnOk } : {}),
          ...(onCancel ? { onCancel: handleOnClose } : {}),
          okText: onOkText,
          cancelText: onCancelText,
          danger,
        }}>
        <ContentContainer>{content}</ContentContainer>
      </ModalWrapper>,
      el,
    );
  }
}
const modal = new Modal();
export { modal };
